import React from 'react';
import styled, { css } from 'styled-components';
import SpinnerOverlay from 'base/components/SpinnerOverlay';
import Wrapper from '../../components/Wrapper';
import theme from '../../../theme';

const Img = styled.img`
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  opacity: 1;
  ${(props) => props.isUploading && css`
    opacity: 0.5;
  `}
`;

const baseURL = `${process.env.REACT_APP_API_URL}/api/rest`;

function Image({
  node, isFocused, readOnly, attributes,
}) {
  const placeholderSrc = node.data.get('placeholderSrc');
  const id = node.data.get('id');
  const isUploading = node.data.get('isUploading');

  const preview = <Img src={placeholderSrc} alt="" />;
  const token = localStorage.getItem('accessToken');

  return (
    <Wrapper isFocused={isFocused} readOnly={readOnly} {...attributes}>
      {isUploading && <SpinnerOverlay background="rgba(255, 255, 255, 0.5)" color={theme.colors.dark} label="Uploading..." />}
      {id
        ? <Img src={`${baseURL}/images/${id}?jwt=${token}`} alt="" />
        : preview}
    </Wrapper>
  );
}

export default Image;
